export const translations = {
  en: {
    nav: {
      home: 'Home',
      products: 'Products',
      solutions: 'Solutions',
      tryFree: 'Try Free'
    },
    hero: {
      title: 'Cross-border E-commerce Data Analytics Expert',
      subtitle: 'Empowering Global Brands',
      description: 'Specialized in Amazon, TikTok Shop data analytics\nDrive your cross-border e-commerce growth with data',
      getStarted: 'Get Started',
      watchDemo: 'Watch Demo'
    },
    products: {
      title: 'Our Products',
      subtitle: 'One-stop data analytics solution for all your e-commerce needs',
      items: [
        {
          title: "Cross-platform Data Integration",
          description: "One-stop integration of Amazon, TikTok Shop, Shopee and other platforms, real-time synchronization of orders, traffic, and advertising data."
        },
        {
          title: "Smart Sales Analytics",
          description: "Deep analysis of product performance, sales trends, and profit margins to optimize product mix and pricing strategy."
        },
        {
          title: "Advertising Analytics",
          description: "Track advertising performance, analyze key metrics like ACOS and ROAS, optimize ad budget allocation."
        }
      ]
    },
    features: {
      title: 'Why Choose Antworers',
      subtitle: '10 years of data analytics experience, serving over 500 businesses',
      items: [
        {
          title: "Multi-platform Data Sync",
          description: "Support major platforms including Amazon, TikTok Shop, ensuring real-time data synchronization."
        },
        {
          title: "Competitive Analysis",
          description: "Monitor competitor pricing, sales, and ratings to identify market opportunities."
        },
        {
          title: "Data Security",
          description: "Compliant with Amazon MWS and platform API specifications, ensuring data security."
        }
      ]
    },
    cases: {
      title: 'Case Studies',
      subtitle: 'We are committed to providing practical and efficient data analytics solutions',
      more: 'More businesses choose us',
      industries: ['F&B Chain', 'E-commerce', 'Manufacturing', 'Services']
    },
    // Products 页面翻译
    productsPage: {
      hero: {
        title: 'Cross-border E-commerce Data Analytics Solutions',
        subtitle: 'One-stop integration of Amazon, TikTok Shop and other platform data, helping sellers make data-driven decisions'
      },
      products: [
        {
          id: 'analytics',
          title: 'Cross-platform Data Analytics',
          description: 'Integrate multi-platform data, providing unified analytics interface',
          features: [
            {
              title: 'Sales Data Analytics',
              points: [
                'SKU-level performance tracking',
                'Multi-platform sales comparison',
                'Profit and cost analysis',
                'Seasonal trend analysis'
              ]
            },
            {
              title: 'Inventory Management',
              points: [
                'Real-time inventory monitoring',
                'Smart replenishment alerts',
                'Cross-platform inventory sync',
                'Slow-moving stock alerts'
              ]
            }
          ]
        },
        {
          id: 'advertising',
          title: 'Advertising Analytics',
          description: 'Optimize advertising performance, improve ROI',
          features: [
            {
              title: 'Ad Performance Tracking',
              points: [
                'ACOS/ROAS real-time monitoring',
                'Keyword performance analysis',
                'Bidding strategy optimization',
                'Ad budget allocation'
              ]
            },
            {
              title: 'Competitor Ad Analysis',
              points: [
                'Competitor strategy tracking',
                'Market opportunity analysis',
                'Keyword overlap analysis',
                'Bidding suggestions'
              ]
            }
          ]
        },
        {
          id: 'automation',
          title: 'Smart Operations Automation',
          description: 'Automate daily operations tasks',
          features: [
            {
              title: 'Price Management',
              points: [
                'Smart pricing strategy',
                'Competitor price monitoring',
                'Profit threshold protection',
                'Promotion price management'
              ]
            },
            {
              title: 'Review Management',
              points: [
                'Automatic review response',
                'Negative review alerts',
                'Review sentiment analysis',
                'Review statistics'
              ]
            }
          ]
        }
      ],
      cta: {
        title: 'Start Using Antworers Data Analytics Platform',
        tryFree: 'Try Free for 14 Days',
        bookDemo: 'Book a Demo'
      }
    },

    // Solutions 页面翻译
    solutionsPage: {
      hero: {
        title: 'Cross-border E-commerce Solutions',
        subtitle: 'Professional data analytics solutions for different platforms'
      },
      solutions: [
        {
          id: 'amazon',
          title: 'Amazon Seller Solutions',
          description: 'Data analytics tools designed for Amazon platform sellers',
          painPoints: [
            'Difficult to evaluate PPC ad performance',
            'Complex multi-marketplace management',
            'Inventory management pressure',
            'Pricing strategy optimization challenges'
          ],
          features: [
            {
              title: 'Multi-marketplace Integration',
              description: 'Automatically sync sales, inventory, and advertising data from all marketplaces'
            },
            {
              title: 'PPC Optimization',
              description: 'Smart analysis of ad performance, optimize keywords and bidding strategies'
            },
            {
              title: 'Smart Replenishment',
              description: 'Auto-calculate optimal replenishment timing and quantity based on sales forecast'
            }
          ]
        },
        {
          id: 'tiktok',
          title: 'TikTok Shop Solutions',
          description: 'Help TikTok sellers achieve data-driven growth',
          painPoints: [
            'Time-consuming livestream data analysis',
            'Difficult to track product performance',
            'Hard to evaluate follower engagement',
            'Inventory turnover pressure'
          ],
          features: [
            {
              title: 'Livestream Analytics',
              description: 'Monitor livestream data in real-time, analyze best selling times and product combinations'
            },
            {
              title: 'Product Performance',
              description: 'Deep analysis of conversion rates and engagement rates'
            },
            {
              title: 'Follower Behavior',
              description: 'Understand follower shopping preferences for precise marketing'
            }
          ]
        },
        {
          id: 'multi-channel',
          title: 'Multi-platform Operations',
          description: 'Cross-platform data integration and analysis',
          painPoints: [
            'Fragmented platform data',
            'Chaotic inventory management',
            'Low operational efficiency',
            'Delayed decision information'
          ],
          features: [
            {
              title: 'Unified Data Center',
              description: 'Integrate all platform data, provide unified analytics interface'
            },
            {
              title: 'Smart Inventory',
              description: 'Optimize inventory allocation based on platform sales forecasts'
            },
            {
              title: 'Cross-platform Analysis',
              description: 'Compare performance across platforms to optimize resource allocation'
            }
          ]
        }
      ],
      consultation: {
        title: 'Need More Help?',
        subtitle: 'Our solution experts are ready to provide professional consultation',
        button: 'Book Consultation'
      }
    }
  },
  zh: {
    nav: {
      home: '首页',
      products: '产品',
      solutions: '解决方案',
      tryFree: '免费试用'
    },
    hero: {
      title: '跨境电商数据分析专家',
      subtitle: '助力品牌全球化',
      description: '专注亚马逊、TikTok Shop等平台数据分析\n让数据驱动您的跨境电商业务增长',
      getStarted: '免费试用',
      watchDemo: '查看演示'
    },
    products: {
      title: '产品服务',
      subtitle: '一站式数据分析解决方案，满足企业各类数据分析与可视化需求',
      items: [
        {
          title: "跨平台数据整合",
          description: "一站式集成亚马逊、TikTok Shop、Shopee等平台数据，实时同步订单、流量、广告数据。"
        },
        {
          title: "智能销售分析",
          description: "深度分析产品表现、销售趋势、利润率，智能识别畅销品和滞销品，助您优化产品结构和定价策略。"
        },
        {
          title: "广告投放分析",
          description: "追踪广告投放效果，分析ACOS、ROAS等关键指标，智能优化广告预算分配，提升广告投资回报率。"
        }
      ]
    },
    features: {
      title: '为什么选择 Antworers',
      subtitle: '十年数据分析经验，为超过500家企业提供数据分析服务',
      items: [
        {
          title: "多平台数据同步",
          description: "支持亚马逊、TikTok Shop、Shopee等主流平台，自动同步订单、库存、广告数据，确保数据实时性。"
        },
        {
          title: "智能竞品分析",
          description: "监控竞品价格、销量、评分变化，及时发现市场机会，制定竞争策略。"
        },
        {
          title: "数据安全保障",
          description: "符合亚马逊MWS、平台API授权规范，数据传输加密，保障店铺数据安全。"
        }
      ]
    },
    cases: {
      title: '客户案例',
      subtitle: '我们始终致力于为中小企业提供实用、高效的数据分析解决方案',
      more: '更多企业选择了我们',
      industries: ['餐饮连锁', '电商零售', '制造业', '服务业']
    },
    // Products 页面翻译
    productsPage: {
      hero: {
        title: '跨境电商数据分析解决方案',
        subtitle: '一站式集成亚马逊、TikTok Shop等平台数据，助力卖家实现数据驱动决策'
      },
      products: [
        {
          id: 'analytics',
          title: '跨平台数据分析',
          description: '整合多平台数据，提供统一的分析界面',
          features: [
            {
              title: '销售数据分析',
              points: [
                'SKU级别销售表现追踪',
                '多平台销售数据对比',
                '利润率和成本分析',
                '季节性趋势分析'
              ]
            },
            {
              title: '库存管理优化',
              points: [
                '实时库存监控',
                '智能补货提醒',
                '跨平台库存同步',
                '滞销品预警'
              ]
            }
          ]
        },
        {
          id: 'advertising',
          title: '广告投放分析',
          description: '优化广告效果，提升投资回报',
          features: [
            {
              title: '广告效果追踪',
              points: [
                'ACOS/ROAS实时监控',
                '关键词效果分析',
                '竞价策略优化',
                '广告预算分配'
              ]
            },
            {
              title: '竞品广告分析',
              points: [
                '竞品投放策略追踪',
                '市场机会分析',
                '关键词重合度分析',
                '竞价建议'
              ]
            }
          ]
        },
        {
          id: 'automation',
          title: '智能运营自动化',
          description: '自动化处理日常运营任务',
          features: [
            {
              title: '价格管理',
              points: [
                '智能调价策略',
                '竞品价格监控',
                '利润阈值保护',
                '促销价格管理'
              ]
            },
            {
              title: '评价管理',
              points: [
                '自动评价回复',
                '差评预警',
                '评价情感分析',
                '评价数据统计'
              ]
            }
          ]
        }
      ],
      cta: {
        title: '开始使用 Antworers 数据分析平台',
        tryFree: '免费试用14天',
        bookDemo: '预约演示'
      }
    },

    // Solutions 页面翻译
    solutionsPage: {
      hero: {
        title: '跨境电商解决方案',
        subtitle: '针对不同平台特点，提供专业的数据分析解决方案'
      },
      solutions: [
        {
          id: 'amazon',
          title: '亚马逊卖家解决方案',
          description: '专为亚马逊平台卖家打造的数据分析工具',
          painPoints: [
            'PPC广告投放效果难以评估',
            '多站点数据管理复杂',
            '库存管理压力大',
            '定价策略优化困难'
          ],
          features: [
            {
              title: '多站点数据整合',
              description: '自动同步所有站点的销售、库存、广告数据，统一管理和分析'
            },
            {
              title: 'PPC广告优化',
              description: '智能分析广告效果，优化关键词和竞价策略，降低ACOS'
            },
            {
              title: '智能补货提醒',
              description: '基于销售预测，自动计算最佳补货时间和数量'
            }
          ]
        },
        {
          id: 'tiktok',
          title: 'TikTok Shop解决方案',
          description: '帮助TikTok卖家实现数据驱动增长',
          painPoints: [
            '直播数据分析耗时',
            '商品表现难以追踪',
            '粉丝互动效果难评估',
            '库存周转压力大'
          ],
          features: [
            {
              title: '直播数据分析',
              description: '实时监控直播间数据，分析最佳带货时段和商品组合'
            },
            {
              title: '商品表现追踪',
              description: '深入分析商品转化率、互动率，优化选品策略'
            },
            {
              title: '粉丝行为分析',
              description: '了解粉丝购物偏好，制定精准营销策略'
            }
          ]
        },
        {
          id: 'multi-channel',
          title: '多平台运营解决方案',
          description: '跨平台数据整合与分析',
          painPoints: [
            '多平台数据割裂',
            '库存管理混乱',
            '运营效率低下',
            '决策信息滞后'
          ],
          features: [
            {
              title: '统一数据中心',
              description: '整合所有平台数据，提供统一的分析界面'
            },
            {
              title: '智能库存分配',
              description: '根据各平台销售预测，优化库存分配策略'
            },
            {
              title: '跨平台对比分析',
              description: '对比不同平台的表现，优化资源分配'
            }
          ]
        }
      ],
      consultation: {
        title: '需要更多帮助？',
        subtitle: '我们的解决方案专家随时为您提供专业咨询',
        button: '预约咨询'
      }
    }
  }
};
